export function getEnvURI() {
  const domain = document.domain;
  let mpDomain = 'mpassportsit.cnsuning.com';
  switch (domain) {
      case 'fuwusit.cnsuning.com':
          mpDomain = 'mpassportsit.cnsuning.com'
          break;
      case 'fuwupre.cnsuning.com':
          mpDomain = 'mpassportpre.cnsuning.com'
          break;
      case 'fuwu.suning.com':
          mpDomain = 'mpassport.suning.com'
          break;
      default:
          break;
  }
  return  mpDomain
}

export function getLoginUrl() {
  const baseUri = getEnvURI();
  const fuwuIssueUri = encodeURIComponent(`https://${document.domain}/fuwu/customTask/index.htm#/square`);
  const authUri = encodeURIComponent(`https://${document.domain}/fuwu/auth?targetUrl=${fuwuIssueUri}`);
  const loginUrl = `https://${baseUri}/ids/login?service=${authUri}&loginTheme=fuwu`;
  return loginUrl
}

function getFwsDomain() {
  const domain = document.domain;
  let fwsDomain = 'fws.cnsuning.com';
  switch (domain) {
    case 'fuwusit.cnsuning.com':
      fwsDomain = 'fwssit.cnsuning.com';
        break;
    case 'fuwupre.cnsuning.com':
      fwsDomain = 'fwspre.cnsuning.com';
        break;
    case 'fuwu.suning.com':
      fwsDomain = 'fws.suning.com';
        break;
    default:
        break;
}
return  fwsDomain
}

export function gotoFwsCustomzied() {
  const domain = getFwsDomain();
  const url = `http://${domain}/fws/customized/showPage.action`;
  window.open(url, '_blank');
}

export function gotoFwsProviderQualification() {
  const domain = getFwsDomain();
  const url = `http://${domain}/fws/account/serviceProviderQualification.action`;
  window.open(url, '_blank');
}